import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSettings } from "@/lib/settings";
import { toast } from "sonner";

/**
 * Block public access to a B2C product when admin has switched it off.
 * Pass the settings flag key (e.g. "product_hotel"). When the flag is
 * `false`, the user is bounced to the home page with a toast.
 */
export default function SiteServiceGuard({ flagKey, label, children }) {
  const { settings } = useSettings();
  const navigate = useNavigate();
  const location = useLocation();
  const off = settings?.[flagKey] === false;

  useEffect(() => {
    if (off) {
      toast.error(`${label} is currently unavailable.`);
      navigate("/", { replace: true, state: { from: location.pathname } });
    }
  }, [off, label, navigate, location.pathname]);

  if (off) return null;
  return children;
}
